import { CreateElement } from "vue";
import i18n from "@/i18n";
import _ from "@/boot/lodash";
import { DataModules } from "@/store/modules/data";
import { DefaultFilters as CustomFieldsFilters } from "@/data/filters/customFields";
import { DefaultSorters as CustomFieldsSorters } from "@/data/sorters/customFields";
import { IImportMappingSource } from "@/models/imports";
import { ICustomField } from "@/models/brands";
import { UpmindObjectMap } from "@/data/enums/objects";

const getObjectName = (object_type: ICustomField["object_type"]) => {
  const map = UpmindObjectMap()[object_type];
  return _.get(map, "name", object_type) as string;
};

const firstLabel = (h: CreateElement, customField: ICustomField) => {
  return h("p", {}, [
    h("span", {}, `${getObjectName(customField.object_type)}: `),
    h("strong", {}, customField.name)
  ]);
};

const secondLabel = (h: CreateElement, customField: ICustomField) => {
  return h("p", { class: "is-size-8" }, [
    h("span", { class: "has-text-info" }, customField.display_type),
    h(
      "span",
      { class: "has-text-grey-light" },
      ` • ${i18n.t("_.id_#", { id: customField.id })}`
    )
  ]);
};

export const CustomFieldSource: IImportMappingSource = {
  props: {
    availableFilters: CustomFieldsFilters,
    availableSorters: CustomFieldsSorters(),
    usedDataModule: DataModules.CUSTOM_FIELDS,
    guardFunctionalities: ["list_client_fields"],
    storeParams: querySearch => {
      return querySearch ? { "filter[name|like]": `%${querySearch}%` } : {};
    }
  },
  render: {
    id: (customField: ICustomField) => customField.id,
    firstLabel: (h: CreateElement, customField: ICustomField) =>
      firstLabel(h, customField),
    secondLabel: (h: CreateElement, customField: ICustomField) =>
      secondLabel(h, customField),
    media: null
  }
};
